/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-cycle */
import { FC } from 'react';
import clsx from 'clsx';
import Image from 'next/image';
import { IInformativeModalProps } from '../../../blades/informativeModal/@types';
import RichText from '../../RichText';
import Typo from '../../Typo';
import styles from './adminPopUp.module.sass';
import utils from '../../../utils';

const adminPopUp: FC<IInformativeModalProps> = props => {
  const { heading, description, footer, image } = props;
  return (
    <div className={`has-text-centered ${styles.challengePopUp}`}>
      <div className={clsx(styles.section)}>
        <Typo h2>{heading}</Typo>
      </div>
      <Image
        src={`https:${image?.fields.file.url}`}
        loader={utils.imageLoader}
        width={240}
        height={240}
        alt={image?.fields.description}
      />
      <div className={clsx('is-bgcolor-Grey', styles.section)}>
        {description && (
          <div className={styles.bodyContent}>
            <RichText document={description} />
          </div>
        )}
      </div>
      <div className={clsx(styles.section)}>{footer && <RichText document={footer} />}</div>
    </div>
  );
};

export default adminPopUp;
// <!--<Image src={image.src} alt={image.title} /> -->
